export default __webpack_public_path__ + "static/media/step-direction.6209c307.svg";